import React from 'react';

import { Text } from './Heading.styles';

import { HeadingVariant } from './types';

export type HeadingProps = {
  /**
   * Text color
   */
  color?: string;
  /**
   * Predefined text variant
   */
  variant?: HeadingVariant;
  /**
   * React children nodes
   */
  children: React.ReactNode;
};

const Heading = ({
  variant = 'h1',
  color = 'black.main',
  children,
}: HeadingProps) => (
  <Text as={variant} color={color} variant={variant}>
    {children}
  </Text>
);

export default Heading;
